module.exports = __webpack_public_path__ + "img/icon (12).25c5748a.png";